import SewaClientContractTable from "../components/ContractSummary/SewaContract";
import MainLayout from "../layout/MainLayout";
import AirContract from "../components/ContractSummary/AirContract";
import { useAuth } from "../Auths/CheckUser";

const Summary = () =>{
const {user} = useAuth()

  return(
    <MainLayout>
    
      {user.role === 'sewa-agent' && <SewaClientContractTable/>}
      {user.role === 'air-agent' && <AirContract/>}
    </MainLayout>
  );
}

export default Summary;